import React, { FC, useContext, ReactNode } from "react";
import { observer } from 'mobx-react-lite';
import { TreeNode, TreeNodeLabel } from '../../TreeNode';
import { InstructionNodeProps } from '../InstructionNodeFactory';
import { LeftPaneContext } from '../../../LeftPaneContext';
import { ActuatorInstruction, Axis } from '../../../../../../machinelogic/types';

interface ActuatorNodeProps extends Omit<InstructionNodeProps, 'instruction'> {
  instruction: ActuatorInstruction
}

const getInstructionLabelName = (instruction: ActuatorInstruction, axis: Axis | undefined): ReactNode => {

  const axisName = axis?.name || "UNKNOWN Axis";
  const unit = axis?.unit || "";


  switch(instruction.name) {
    case "home":
      return `Move ${axisName} to home`;
    case "moveAbsolute":
      return `Move ${axisName} to ${instruction.parameters.position} ${unit}`;
    case "moveRelative":
      return `Move ${axisName} relative ${instruction.parameters.distance} ${unit}`;

    // angles
    case "moveToClosestAngle":
      return `Move ${axisName} to ${instruction.parameters.angle} ${unit}`;
    case "defineAngle":
      return `Set ${axisName} to ${instruction.parameters.angle} ${unit}`;

      // stop motion
    case "stopActuatorMotion":
      return `Stop ${axisName} Motion`;
    case "stopAllMotion":
      return 'Stop All Motion';

      // continuous motion
    case "setContinuousMove":
      return `Start ${axisName} Continuous Move ${instruction.parameters.speed} ${unit}/s`;
    case "moveVFD":
      return `Start ${axisName} Continuous Move ${instruction.parameters.direction}`;
    case "stopContinuousMove":
    case "stopVFD":
      return `Stop ${axisName} Continuous Move`;
  }
};

export const ActuatorNode: FC<ActuatorNodeProps> = observer(({instruction, titleClassName = '', isSelected, isInvalid, onClick}) => {

  const { library } = useContext(LeftPaneContext);

  let axis: Axis | undefined = undefined;

  if('axis' in instruction.parameters) {
    const instructionAxis: Axis = library.getConfigManager().getAxisByUuid(instruction.parameters.axis);
    axis = instructionAxis;
  }

  const instructionLabel = <TreeNodeLabel
    icon='icon-motor'
    name={getInstructionLabelName(instruction, axis)}
    isSelected={isSelected}
    isInvalid={isInvalid}
    onClick={onClick}
  />;

  return (
    <TreeNode title={instructionLabel} titleClassName={titleClassName} />
  );
});
